import { withInstall } from '../_util'

import Tabs from './tabs.vue'
import TabPane from './tab-pane.vue'

export default withInstall<
  typeof Tabs,
  {
    TabPane: typeof TabPane
  }
>(Tabs, {
  TabPane,
})

export * from './tabs'
export * from './tab-pane'
